import {workspaceIdentityKey} from '../workspace/workspaceIdentityScope.js'
import {selectionCatalog} from './cohortSelection.js'
// All URL choices are included, even a filter yielding the same rows. Data scope
// comes from the current server-backed caller; it is not authorization.
export function cohortQueueScope({params, dataScope, user, isAuthed, session, access, jobs, loading, error}) {
  if (!isAuthed || !user?.id || loading || error || typeof dataScope !== 'string' || !dataScope || access?.checking || access?.available('platform.artwork') !== true || access?.available('artwork') !== true) return null
  const filters = new URLSearchParams(params); filters.sort()
  const filterScope = JSON.stringify(['artwork-engine-queue-v1', filters.toString(), dataScope, workspaceIdentityKey(user, 'authenticated'), session, access.data?.version])
  // This is an internal equality signature, not a submitted field. Keep the
  // complete account book/filter binding rather than rejecting large books.
  const catalog = selectionCatalog(jobs)
  if (catalog.unavailable) return null
  return {filterScope, identity: JSON.stringify([filterScope, catalog.signature])}
}
